function BikeFormatConverterTransformer(Util, jsonMapper) {

	function convertDateAndTimeTheGuidewireWay(dateTime) {
		var format = "{0} at {1} AEST" ;
		return Util.stringFormat(format, dateTime.format('Do MMM YYYY') , dateTime.format('h:mma')) ;
	}

	function convertDate(dateString) {
		var date = moment(dateString, 'DD/MM/YYYY') ;
		var formattedDate = date.format('YYYY-MM-DD') ;
		if ( formattedDate != "Invalid date")
			return formattedDate;


		// throw 'date format exception formatting ' + dateString ;
		return null;
	}
	
	function convertDateToGWTimeZone(dateString) {
		var formattedDate = moment(dateString,'DDMMYYYY').tz("Australia/Sydney").format('YYYY-MM-DD') ;
		if ( formattedDate != "Invalid date")
			return formattedDate;

		return null;
	}

	function convertGender(gender) {
		var gc = {
			male : 'M',
			female : 'F',
			intersex : 'I',
		};

		return gc[gender] ;
	}

	function convertFalsyToUnknown(value) {
		if ( value === null || value === undefined )
			return 'unknown';

		return convertBooleanToYesNo(value) ;
	}

	function convertBooleanToYesNo(value) {
		return value ? 'yes' : 'no' ;
	}

	function convertStringToInt(value) {
		return !!value ? parseInt(value) : value;
	}

	function convertIntToString(value) {
		return !!value ? value.toString() : value;
	}


	var convertValueMapping = {
		'periodStartDate': convertDateToGWTimeZone,

		'policyHolders.*.contact.gender' : convertGender,
		'policyHolders.*.contact.hasClaim' : convertFalsyToUnknown,
		'policyHolders.*.contact.hasConviction' : convertFalsyToUnknown,
		'policyHolders.*.contact.anyLostLicence' : convertFalsyToUnknown,
		'policyHolders.*.contact.anyInfringements' : convertFalsyToUnknown,
		'policyHolders.*.contact.dateOfBirth' : convertDate,
		'policyHolders.*.contact.authorisedPersons.0.person.dateOfBirth' : convertDate,
		'policyHolders.*.contact.authorisedPersons.0.person.gender' : convertGender,


		'motorcycles.0.purchaseDate' : convertDate,

		'motorcycles.0.youngestRiderDOB' : convertDate,
		'motorcycles.0.youngestRiderGender' : convertGender,
		
		'motorcycles.0.motorcycleInfo.modelYear' : convertStringToInt,
		"motorcycles.0.sumInsuredAmount": convertStringToInt,

		// 'motorcycles.0.purchasePrice' : convertIntToString,
		// 'motorcycles.0.sumInsuredAmount' : convertIntToString,
		'motorcycles.0.isFinanced' : convertBooleanToYesNo,

		'motorcycles.0.riders.*.rider.person.dateOfBirth' : convertDate,
		'motorcycles.0.riders.*.rider.person.gender' : convertGender,
		"motorcycles.0.riders.*.rider.hasConviction": convertFalsyToUnknown,
		"motorcycles.0.riders.*.rider.person.hasConviction": convertBooleanToYesNo,
		"motorcycles.0.riders.*.rider.hasClaim": convertFalsyToUnknown,
		"motorcycles.0.riders.*.rider.person.hasClaim": convertBooleanToYesNo,
		"motorcycles.0.riders.*.rider.hasLostLicence": convertFalsyToUnknown,
		"motorcycles.0.riders.*.licensedToRide": convertBooleanToYesNo,
		'motorcycles.0.riders.*.rider.riderHistory.*.year' : convertStringToInt,
		'motorcycles.0.sumInsuredAmount' : convertStringToInt
	};

	function transform(intermediateRequest, userInput) {
		var transformedRequest = jsonMapper.convert(intermediateRequest, convertValueMapping) ;
		return transformedRequest;
	}

	return {
		transform: transform
	}
}
